<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid && !needsFile()">
  <h3 i18n>Préavis de remplacement</h3>
  <p i18n
    >Est-ce que cette nouvelle protection d’assurance servira à remplacer une ou des protection(s)
    existante(s)?</p
  >

  <p-selectButton
    class="title-toggle"
    [options]="booleanAnswerSelectButtons | emTranslate"
    [formControl]="form"
    [allowEmpty]="false"
    optionLabel="label"
    optionValue="value"></p-selectButton>

  @if (form.value) {
    <div class="margin--top-medium">
      <p-fileUpload
        class="remove-file-delete-button"
        [auto]="true"
        [fileLimit]="1"
        [files]="files"
        [disabled]="form.disabled"
        [customUpload]="true"
        [class.read-only]="isReadonly"
        i18n-chooseLabel
        chooseLabel="Choisir un fichier"
        accept=".pdf"
        (onRemove)="removeReplacementNotice()"
        (uploadHandler)="addReplacementNotice($event.files)"></p-fileUpload>
    </div>
  }
</p-card>
